import React from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { css, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    closeBurgerMenu: Function,
};

const BurgerNavContainer: React.FC<Props> = ({ children, closeBurgerMenu }) => {
    const theme = useTheme();

    const closeMenuHandler = () => {
        closeBurgerMenu({ forcedClose: true });
    }

    const style = css`
        position: fixed;
        top: 0;
        width: 100%;
        min-width: ${theme.breakpoints.sizes.xs}px;
        max-height: 100%;
        overflow-y: auto;
        z-index: ${theme.zIndex.zIndexHigh};
        box-shadow: ${theme.borderAndShadow.dropShadow1};
        
        a {
            color: inherit;
            text-decoration: none;
        }
    `;

    return (
        <div css={style}>
            <OutsideClickHandler onOutsideClick={closeMenuHandler}>
                {children}
            </OutsideClickHandler>
        </div>
    );
};

export default BurgerNavContainer;